import React from 'react';
import { Box, Typography } from '@mui/material';
import { ChatBubbleOutline as ChatIcon } from '@mui/icons-material';
import type { ActivityType } from './useUnifiedActivity';

interface ActivityEmptyProps {
  filter: ActivityType;
}

export const ActivityEmpty: React.FC<ActivityEmptyProps> = ({ filter }) => {
  const getMessage = () => {
    switch (filter) {
      case 'note':
        return 'No notes yet. Add a note to keep track of research or personal observations.';
      case 'comment':
        return 'No comments yet. Be the first to comment!';
      case 'memory':
        return 'No memories yet. Share a story or memory to preserve their legacy.';
      default:
        return 'No activity yet. Start by adding a comment, note, or memory.';
    }
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        py: 8,
        textAlign: 'center'
      }}
    >
      <ChatIcon sx={{ fontSize: 64, color: 'text.disabled', mb: 2 }} />
      <Typography variant="body1" color="text.secondary">
        {getMessage()}
      </Typography>
    </Box>
  );
};
